import React from 'react';
import classNames from 'classnames';
import img from '../../assets/starChargeLogo.svg.js';
import './index.less.js';

var SpinLogo = function SpinLogo(props) {
  var _a, _b;
  var size = props.size;
  var spinCls = classNames((_a = {}, _a['ti-spin-logo'] = true, _a["ti-spin-logo-".concat(size)] = true, _a));
  var animationCls = classNames((_b = {}, _b["ti-spin-logo-".concat(size)] = true, _b['ti-spin-logo-content'] = true, _b['ti-spin-animation'] = true, _b));
  return /*#__PURE__*/React.createElement("div", {
    className: "ti-spin"
  }, /*#__PURE__*/React.createElement("div", {
    className: spinCls
  }, /*#__PURE__*/React.createElement("div", {
    className: animationCls
  }), /*#__PURE__*/React.createElement("img", {
    className: "ti-logo-".concat(size),
    src: img,
    alt: ""
  })));
};

export { SpinLogo as default };
